import connectSearchBox from 'instantsearch.js/es/connectors/search-box/connectSearchBox.js';
import { useConnector } from '../hooks/useConnector.js';

function useSearchBox(props, additionalWidgetProperties) {
    return useConnector(connectSearchBox, props, additionalWidgetProperties);
}

export { useSearchBox };
